export const productKeys = {
  all: ["adm-products"] as const,
};

export const ordersKeys = {
  all: ["adm-orders"] as const,
};

export const notificationKeys = {
  all: ["adm-notification"] as const,
  unread: ["adm-unread-notification"] as const,
};

export const inventoryKeys = {
  all: ["adm-inventory"] as const,
}